import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLocationOnSvg } from "./IconLocationOnSvg.mjs";
const IconLocationOn = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLocationOnSvg, ...iconProps });
};
export {
  IconLocationOn
};
